import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import withPermissions from "permissions/withPermissions";
import { AccessDeniedState } from "components/items/empty-state";
import ExternalLinkTemplateForm from "../components/external-link-template-form";
import { setExternalLinkTemplateFormDisabled, fetchExternalLinkTemplate } from "../actions/external-link-template.actions";
import { isFormDisabled, getExternalLinkTemplates } from "../reducers/external-link-template.reducers";

const ExternalLinkTemplateEditPage = ({
  hasPermissionExternalLinkTemplateMaintain,
}) => {
  const dispatch = useDispatch();
  const disabled = useSelector(isFormDisabled);
  const externalLinks = useSelector(getExternalLinkTemplates);

  // Fetch external links on mount
  useEffect(() => {
    dispatch(fetchExternalLinkTemplate());
  }, [dispatch]);

  // Reset form to disabled state when component unmounts (user leaves the tab)
  useEffect(() => () => {
    dispatch(setExternalLinkTemplateFormDisabled(true));
  }, [dispatch]);

  const handleSucceed = () => {
    dispatch(setExternalLinkTemplateFormDisabled(true));
    dispatch(fetchExternalLinkTemplate());
  };

  if (!hasPermissionExternalLinkTemplateMaintain) {
    return <AccessDeniedState />;
  }

  return (
    <ExternalLinkTemplateForm
      externalLinks={externalLinks}
      disabled={disabled}
      onCancel={() => dispatch(setExternalLinkTemplateFormDisabled(true))}
      onSucceed={handleSucceed}
    />
  );
};

export default withPermissions("ExternalLinkTemplateMaintain")(ExternalLinkTemplateEditPage);
